import { useTranslation } from 'react-i18next'

export default function AgentsSvg() {
  const { t } = useTranslation()

  return (
    <svg
      className="block w-full h-auto max-w-[1100px] mx-auto"
      viewBox="0 0 1080 500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="jaShadow" x="-4%" y="-4%" width="108%" height="112%">
          <feDropShadow dx="0" dy="2" stdDeviation="4" floodColor="#1B2B3A" floodOpacity="0.1" />
        </filter>
        <marker
          id="jaArrow"
          viewBox="0 0 10 10"
          refX="9"
          refY="5"
          markerWidth="7"
          markerHeight="7"
          orient="auto-start-reverse"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#4A5E6D" />
        </marker>
      </defs>

      {/* ORCHESTRATOR */}
      <rect x="390" y="20" width="300" height="65" rx="12" fill="#1B2B3A" filter="url(#jaShadow)" />
      <text
        x="540"
        y="46"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: '#00A693',
          fontWeight: 700,
          letterSpacing: 2,
        }}
      >
        {t('caseJhsf.agentFlow.orchestratorRole')}
      </text>
      <text
        x="540"
        y="66"
        textAnchor="middle"
        style={{ fontFamily: 'var(--font-display)', fontSize: 13, fill: '#FFF', fontWeight: 600 }}
      >
        {t('caseJhsf.agentFlow.orchestratorName')}
      </text>

      <line
        x1="540"
        y1="85"
        x2="540"
        y2="120"
        stroke="#4A5E6D"
        strokeWidth="2"
        markerEnd="url(#jaArrow)"
      />

      {/* DIRECTOR */}
      <rect
        x="390"
        y="125"
        width="300"
        height="65"
        rx="12"
        fill="#00A693"
        filter="url(#jaShadow)"
      />
      <text
        x="540"
        y="151"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 9,
          fill: 'rgba(255,255,255,.7)',
          fontWeight: 700,
          letterSpacing: 2,
        }}
      >
        {t('caseJhsf.agentFlow.directorRole')}
      </text>
      <text
        x="540"
        y="173"
        textAnchor="middle"
        style={{ fontFamily: 'var(--font-display)', fontSize: 13, fill: '#FFF', fontWeight: 600 }}
      >
        {t('caseJhsf.agentFlow.directorName')}
      </text>

      {/* Arrows to sub-agents */}
      <line
        x1="420"
        y1="190"
        x2="108"
        y2="265"
        stroke="#4A5E6D"
        strokeWidth="1.5"
        markerEnd="url(#jaArrow)"
      />
      <line
        x1="460"
        y1="190"
        x2="325"
        y2="265"
        stroke="#4A5E6D"
        strokeWidth="1.5"
        markerEnd="url(#jaArrow)"
      />
      <line
        x1="540"
        y1="190"
        x2="540"
        y2="265"
        stroke="#4A5E6D"
        strokeWidth="1.5"
        markerEnd="url(#jaArrow)"
      />
      <line
        x1="620"
        y1="190"
        x2="755"
        y2="265"
        stroke="#4A5E6D"
        strokeWidth="1.5"
        markerEnd="url(#jaArrow)"
      />
      <line
        x1="660"
        y1="190"
        x2="970"
        y2="265"
        stroke="#4A5E6D"
        strokeWidth="1.5"
        markerEnd="url(#jaArrow)"
      />

      {/* Lane labels */}
      <rect x="15" y="240" width="200" height="18" rx="9" fill="#E0F5F2" />
      <text
        x="115"
        y="253"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 8,
          fill: '#007D6E',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.agentFlow.laneCorretorLabel')}
      </text>

      <rect x="865" y="240" width="200" height="18" rx="9" fill="#E0F5F2" />
      <text
        x="965"
        y="253"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 8,
          fill: '#007D6E',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.agentFlow.laneClienteLabel')}
      </text>

      {/* SUB-AGENT 1 */}
      <rect
        x="10"
        y="270"
        width="196"
        height="85"
        rx="10"
        fill="#FFF"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jaShadow)"
      />
      <rect x="14" y="274" width="188" height="4" rx="2" fill="#E0F5F2" />
      <text
        x="108"
        y="302"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 8,
          fill: '#007D6E',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.agentFlow.sub1Role')}
      </text>
      <text
        x="108"
        y="320"
        textAnchor="middle"
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 11,
          fill: '#1B2B3A',
          fontWeight: 700,
        }}
      >
        {t('caseJhsf.agentFlow.sub1Name')}
      </text>
      <text
        x="108"
        y="340"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.agentFlow.sub1Desc')}
      </text>

      {/* SUB-AGENT 2 */}
      <rect
        x="226"
        y="270"
        width="196"
        height="85"
        rx="10"
        fill="#FFF"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jaShadow)"
      />
      <rect x="230" y="274" width="188" height="4" rx="2" fill="#E0F5F2" />
      <text
        x="324"
        y="302"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 8,
          fill: '#007D6E',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.agentFlow.sub2Role')}
      </text>
      <text
        x="324"
        y="320"
        textAnchor="middle"
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 11,
          fill: '#1B2B3A',
          fontWeight: 700,
        }}
      >
        {t('caseJhsf.agentFlow.sub2Name')}
      </text>
      <text
        x="324"
        y="340"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.agentFlow.sub2Desc')}
      </text>

      {/* SUB-AGENT 3 */}
      <rect
        x="442"
        y="270"
        width="196"
        height="85"
        rx="10"
        fill="#FFF"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jaShadow)"
      />
      <rect x="446" y="274" width="188" height="4" rx="2" fill="#E0F5F2" />
      <text
        x="540"
        y="302"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 8,
          fill: '#007D6E',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.agentFlow.sub3Role')}
      </text>
      <text
        x="540"
        y="320"
        textAnchor="middle"
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 11,
          fill: '#1B2B3A',
          fontWeight: 700,
        }}
      >
        {t('caseJhsf.agentFlow.sub3Name')}
      </text>
      <text
        x="540"
        y="340"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.agentFlow.sub3Desc')}
      </text>

      {/* SUB-AGENT 4 */}
      <rect
        x="658"
        y="270"
        width="196"
        height="85"
        rx="10"
        fill="#FFF"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jaShadow)"
      />
      <rect x="662" y="274" width="188" height="4" rx="2" fill="#E0F5F2" />
      <text
        x="756"
        y="302"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 8,
          fill: '#007D6E',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.agentFlow.sub4Role')}
      </text>
      <text
        x="756"
        y="320"
        textAnchor="middle"
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 11,
          fill: '#1B2B3A',
          fontWeight: 700,
        }}
      >
        {t('caseJhsf.agentFlow.sub4Name')}
      </text>
      <text
        x="756"
        y="340"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.agentFlow.sub4Desc')}
      </text>

      {/* SUB-AGENT 5 */}
      <rect
        x="874"
        y="270"
        width="196"
        height="85"
        rx="10"
        fill="#FFF"
        stroke="#00A693"
        strokeWidth="2"
        filter="url(#jaShadow)"
      />
      <rect x="878" y="274" width="188" height="4" rx="2" fill="#E0F5F2" />
      <text
        x="972"
        y="302"
        textAnchor="middle"
        style={{
          fontFamily: 'monospace',
          fontSize: 8,
          fill: '#007D6E',
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {t('caseJhsf.agentFlow.sub5Role')}
      </text>
      <text
        x="972"
        y="320"
        textAnchor="middle"
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 11,
          fill: '#1B2B3A',
          fontWeight: 700,
        }}
      >
        {t('caseJhsf.agentFlow.sub5Name')}
      </text>
      <text
        x="972"
        y="340"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 9, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.agentFlow.sub5Desc')}
      </text>

      {/* Tech annotations */}
      <rect x="30" y="378" width="155" height="26" rx="6" fill="#E8FDE8" />
      <text
        x="108"
        y="396"
        textAnchor="middle"
        style={{ fontFamily: 'monospace', fontSize: 8, fill: '#27AE60', fontWeight: 600 }}
      >
        {t('caseJhsf.agentFlow.tech1')}
      </text>

      <rect x="248" y="378" width="155" height="26" rx="6" fill="#F3E8FD" />
      <text
        x="325"
        y="396"
        textAnchor="middle"
        style={{ fontFamily: 'monospace', fontSize: 8, fill: '#8B5CF6', fontWeight: 600 }}
      >
        {t('caseJhsf.agentFlow.tech2')}
      </text>

      <rect x="463" y="378" width="155" height="26" rx="6" fill="#E8F4FD" />
      <text
        x="540"
        y="396"
        textAnchor="middle"
        style={{ fontFamily: 'monospace', fontSize: 8, fill: '#2D9CDB', fontWeight: 600 }}
      >
        {t('caseJhsf.agentFlow.tech3')}
      </text>

      <rect x="678" y="378" width="155" height="26" rx="6" fill="#E8FDE8" />
      <text
        x="755"
        y="396"
        textAnchor="middle"
        style={{ fontFamily: 'monospace', fontSize: 8, fill: '#27AE60', fontWeight: 600 }}
      >
        {t('caseJhsf.agentFlow.tech4')}
      </text>

      <rect x="893" y="378" width="155" height="26" rx="6" fill="#FEF3E6" />
      <text
        x="970"
        y="396"
        textAnchor="middle"
        style={{ fontFamily: 'monospace', fontSize: 8, fill: '#F2994A', fontWeight: 600 }}
      >
        {t('caseJhsf.agentFlow.tech5')}
      </text>

      {/* Flow description */}
      <rect
        x="140"
        y="430"
        width="800"
        height="50"
        rx="8"
        fill="#F7F9FA"
        stroke="#E2E8ED"
        strokeWidth="1"
      />
      <text
        x="540"
        y="452"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 11, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.agentFlow.flowLine1')}
      </text>
      <text
        x="540"
        y="470"
        textAnchor="middle"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: 11, fill: '#4A5E6D', fontWeight: 500 }}
      >
        {t('caseJhsf.agentFlow.flowLine2')}
      </text>
    </svg>
  )
}
